export const INPUT_FIELDS = [
  {
    register: "title",
    placeHolder: "ClinicName",
  },
  {
    register: "shortName",
    placeHolder: "ShortName",
  },
  {
    register: "email",
    placeHolder: "Email",
  },
  {
    register: "phoneNumber",
    placeHolder: "PhoneNumber",
  },
  {
    placeHolder: "ClinicUrl",
    register: "url",
  },
  {
    register: "city",
    placeHolder: "City",
  },
  {
    register: "streetAddress",
    placeHolder: "Address",
  },
  {
    register: "zipCode",
    placeHolder: "ZipCode",
  },
];
